export default __webpack_public_path__ + "static/media/cash.97de791e.svg";